<div class="d-flex">
  <mat-form-field appearance="outline" class="flexer">
    <input
      type="number"
      placeholder="Prijs"
      matInput
      [(ngModel)]="priceLine.price"
      name="price"
      (ngModelChange)="priceChanged($event)"
      [disabled]="disablePriceEdit"
      required
    />
  </mat-form-field>

  <mat-form-field
    *ngIf="priceLine.displaySuffix == null"
    appearance="outline"
    [ngClass]="alignWithBoardPrices ? 'flexer-2-8' : 'flexer-3'"
  >
    <input
      placeholder="Reden"
      matInput
      [(ngModel)]="priceLine.text"
      name="text"
      (ngModelChange)="lineChanged($event)"
      [disabled]="priceLine.placementLine || priceLine.override != null"
      required
    />
  </mat-form-field>

  <mat-form-field
    *ngIf="priceLine.displaySuffix != null"
    appearance="outline"
    [ngClass]="alignWithBoardPrices ? 'flexer-2-8' : 'flexer-3'"
  >
    <input
      placeholder="Reden"
      matInput
      [value]="priceLine.text + ' ' + priceLine.displaySuffix"
      name="text"
      [disabled]="true"
      required
    />
  </mat-form-field>
</div>
